import { Link, useLocation } from 'react-router-dom';
import { LuChevronRight } from 'react-icons/lu';
import { NAV_ITEMS } from '@/app/navigation';
import { useBreadcrumbLabel } from './BreadcrumbContext';

/** Labels for routes that are not in the sidebar. */
const EXTRA_LABELS: Record<string, string> = { '/account': 'My Account' };

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const override = useBreadcrumbLabel();
  const segments = pathname.split('/').filter(Boolean);
  const crumbs: { label: string; to: string }[] = [{ label: 'Home', to: '/dashboard' }];
  let acc = '';
  segments.forEach((seg, i) => {
    acc += `/${seg}`;
    const nav = NAV_ITEMS.find((n) => n.path === acc);
    const isLast = i === segments.length - 1;
    const label = nav?.label ?? EXTRA_LABELS[acc] ?? (isLast && override ? override : seg === 'new' ? 'New' : decodeURIComponent(seg));
    if (acc === '/dashboard') return;
    crumbs.push({ label, to: acc });
  });

  return (
    <nav aria-label="Breadcrumb" className="min-w-0">
      <ol className="flex items-center gap-1 text-xs text-slate-500">
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={c.to + i} className="flex min-w-0 items-center gap-1">
              {i > 0 && <LuChevronRight className="size-3.5 shrink-0 text-slate-400" />}
              {last ? (
                <span className="truncate font-medium text-slate-800" aria-current="page">{c.label}</span>
              ) : (
                <Link to={c.to} className="truncate hover:text-slate-800 hover:underline">{c.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
